import { Injectable, inject } from '@angular/core';
import { IEmployeeInfo } from '@ups/xplat/api/dto';
import { RynReplayRecorderService } from './ryn-replay-recorder.service';

/**
 * Legacy session-recording seam (#30070).
 *
 * The vendor SDK is gone. This service keeps the historical public API so
 * help-desk / Halo callers stay on `smartlookService.sessionUrl()` with zero
 * call-site edits. Live capture is delegated to `RynReplayRecorderService`
 * (no-op when `environment.rynReplay.enabled` is off).
 */
@Injectable({
  providedIn: 'root',
})
export class WebSmartlookService {
  private readonly rynReplay = inject(RynReplayRecorderService);

  /** Mirrors recording start on the in-house recorder. */
  get init(): boolean {
    return this.rynReplay.init;
  }

  setUser(info: IEmployeeInfo): void {
    this.rynReplay.setUser(info);
  }

  sessionUrl(): string | undefined {
    return this.rynReplay.sessionUrl();
  }

  pause(): void {
    this.rynReplay.pause();
  }

  resume(): void {
    this.rynReplay.resume();
  }

  trackEvent(
    name: string,
    properties?: { [key: string]: string | number }
  ): void {
    this.rynReplay.trackEvent(name, properties);
  }
}
